import { memo, useEffect, useState } from "react"
import { Button, /*Switch*/ } from "@mui/material";
import GenericDialog from "components/GenericDialog";
import GenericTitle from "components/GenericTitle";
import IntlMessages from "components/util/IntlMessages";
import CookieConsent from "components/CookieConsent";
// import Alert from "components/@efz/Alert";
import useCookies from "hooks/cookies";
import { useSelector } from "react-redux";
import { getIsUserAuthenticated } from "selectors/user";
import { useNavigate } from "react-router-dom";
import { routeToCookiePolicy } from "services/cookies";

const CustomizeCookiesDialog = ({
    isOpen,
    setIsOpen,
    cookieBannerHandler
}) => {
    const navigate = useNavigate();

    const {
        setCookie,
        // getCookie,
        // CONSENT_COOKIE,
        PLATFORM_CUSTOMIZATION_COOKIE,
        PERSONALIZED_ADVERTISING_COOKIE
    } = useCookies();

    const isUserAuthenticated = useSelector(state => getIsUserAuthenticated(state.user));

    // const _platformCustomizationCookie = getCookie(PLATFORM_CUSTOMIZATION_COOKIE) ?? true;
    // const _personalizedAdvertisingCookie = getCookie(PERSONALIZED_ADVERTISING_COOKIE) ?? true;
    // const _consentCookie = getCookie(CONSENT_COOKIE);

    const [showPolicy, setShowPolicy] = useState(false);
    // const [showWarning, setShowWarning] = useState(false);
    const [policyTypeToShow, setPolicyTypeToShow] = useState(null);

    // const [platformCustomization, setPlatformCustomization] = useState(_platformCustomizationCookie);
    // const [personalizedAdvertising, setPersonalizedAdvertising] = useState(_personalizedAdvertisingCookie);

    const showPolicyHandler = (type = null) => {
        if (!!type) {
            if (!isUserAuthenticated) {
                setPolicyTypeToShow(type);
            } else {
                setIsOpen(false);
                routeToCookiePolicy(navigate, type);
            }
        } else {
            setShowPolicy(false);
        }
    }

    useEffect(() => {
        if (!!policyTypeToShow) {
            setShowPolicy(true);
        } else {
            setShowPolicy(false);
        }
    }, [policyTypeToShow]);

    useEffect(() => {
        if (!showPolicy) {
            setPolicyTypeToShow(null);
        }
    }, [showPolicy]);

    const switchHandler = () => {
        setCookie(PLATFORM_CUSTOMIZATION_COOKIE, true, 365)
        setCookie(PERSONALIZED_ADVERTISING_COOKIE, true, 730)
        setIsOpen(false)
        cookieBannerHandler?.accept()
    }

    // useEffect(() => {
    //     if ((!personalizedAdvertising && _personalizedAdvertisingCookie) || (!platformCustomization && _platformCustomizationCookie)) {
    //         setShowWarning(true) 
    //     } else {
    //         setShowWarning(false)
    //     }
    // }, [platformCustomization, personalizedAdvertising, _platformCustomizationCookie, _personalizedAdvertisingCookie]);

    const dialogTitle = (
        <GenericTitle
            textId="label.cookies.privacySettings"
            redLine
        />
    );

    const dialogBody = (
        <>
            <section className='privacy-section'>
                <div className='privacy-section-content'>
                    <div>
                        <IntlMessages id='dialog.privacy.1' />
                        <br />
                        <ul>
                            <li><IntlMessages id='dialog.privacy.1.1' /></li>
                            <li><IntlMessages id='dialog.privacy.1.2' /></li>
                            <li><IntlMessages id='dialog.privacy.1.3' /></li>
                            <li><IntlMessages id='dialog.privacy.1.4' /></li>
                            <li><IntlMessages id='dialog.privacy.1.5' /></li>
                        </ul>
                        <IntlMessages id='dialog.privacy.2.1' whitespaceEnd /> <span className='link' onClick={() => showPolicyHandler('privacy-policy')}><IntlMessages id='label.here' /></span>
                        <IntlMessages id='dialog.privacy.2.2' whitespaceEnd /> <span className='link' onClick={() => showPolicyHandler('cookies-policy')}><IntlMessages id='label.here' /></span>.
                    </div>
                    <div className='label-category' />
                </div>
            </section>

            <section className='privacy-section'>
                <div className='privacy-section-title'>
                    <div className='privacy-section-title-first-line'>
                        <span><IntlMessages id='dialog.privacy.essential' /></span>
                        <span className='label-category'><IntlMessages id='label.alwaysOn' /></span>
                    </div>
                    <hr />
                </div>
                <div className='privacy-section-content'>
                    <div>
                        <IntlMessages id='dialog.privacy.essential.1' />
                    </div>
                    <div className='label-category' />
                </div>
            </section>

            <section className='privacy-section'>
                <div className='privacy-section-title'>
                    <div className='privacy-section-title-first-line'>
                        <span><IntlMessages id='dialog.privacy.customization' /></span>
                        <span className='label-category'><IntlMessages id='label.alwaysOn' /></span>
                    </div>
                    <hr />
                </div>
                <div className='privacy-section-content'>
                    <div>
                        <IntlMessages id='dialog.privacy.customization.1' />
                        <br />
                        <ul>
                            <li><IntlMessages id='dialog.privacy.customization.1.1' /></li>
                            <li><IntlMessages id='dialog.privacy.customization.1.2' /></li>
                        </ul>
                        <IntlMessages id='dialog.privacy.customization.2' />
                    </div>
                    <div className='label-category' />
                </div>
            </section>

            {/* <section className='privacy-section'>
                <div className='privacy-section-title'>
                    <div className='privacy-section-title-first-line'>
                        <span>Personalized advertising</span>
                        <div className='label-category'>
                            <Switch
                                checked={personalizedAdvertising}
                                onChange={(e) => setPersonalizedAdvertising(e.target.checked)}
                            /> 
                        </div>
                    </div>
                    <hr/>
                </div>
                <div className='privacy-section-content'>
                    <div>
                        These technologies are used to:
                        <br />
                        <ul>
                            <li>Personalize ads;</li>
                            <li>Limit how many times you see an ad;</li>
                            <li>Understand usage through Google Analytics and Hotjar;</li>
                            <li>Understand how you got to Effizency;</li>
                            <li>Provide relevant ads.</li>
                        </ul>
                        We do this with social media, marketing, and analytics partners.
                    </div>
                    <div className='label-category' />
                </div>
                {
                    showWarning && _consentCookie && (
                        <Alert
                            severity='warning'
                            className='mt-2'
                            IntlMessages={'For the changes to take effect, you must reload the page.'}
                        />
                    )
                }
            </section> */}
        </>
    );

    const dialogButtons = (
        <div className="w-100 d-flex justify-content-center privacy-dialog-actions">
            {/* <Button
                className='tertiary-button-2 privacy-dialog-back-button'
                disableRipple
                type={'button'}
                onClick={() => setIsOpen(false)}
                disableFocusRipple
                variant="textSecondary"
            >
                <IntlMessages id="label.back" />
            </Button> */}
            <Button
                className='collective-info-next-button '
                disableRipple
                disableFocusRipple
                color="primary"
                type={'button'}
                onClick={switchHandler}
                variant="contained"
            >
                {/* <IntlMessages id="label.update" /> */}
                <IntlMessages id="label.consent" />
            </Button>
        </div>
    );

    return (
        <>
            {!showPolicy && <GenericDialog
                open={isOpen}
                handleClose={() => setIsOpen(false)}
                title={dialogTitle}
                body={dialogBody}
                buttons={dialogButtons}
                className={'cookies-dialog'}
            />}
            {showPolicy && <CookieConsent type={policyTypeToShow} close={showPolicyHandler} showPolicyHandler={showPolicyHandler} />}
        </>
    );
}

export default memo(CustomizeCookiesDialog);